import { OrganisationService } from 'src/app/services/organisation.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UserService } from 'src/app/services/user.service';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Chart } from 'chart.js';
import * as jquery from 'jquery';
import { map, tap, concatMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'admin-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DatePipe]
})
export class DashboardComponent implements OnInit {

  chartUsers: any;
  chartOrganisations: any;
  chartRevenues: any;

  showDashoard = false;
  usersData = [];
  usersLabels = [];
  organisationData = [];
  organisationLabels = [];
  revenueData = [];
  revenueLabels = [];
  modalText = 'Loading...';
  error = false;

  myDate = new Date();
  today: string;
  todayYmd: string;

  organisations = [];
  organisationVal = 0;

  total_users = 0;
  active_users_percentage = 0;

  constructor(
    private pageTitleService: Title,
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    private organisationService: OrganisationService,
    private userService: UserService
  ) { }


  ngOnInit(): void {
    this.setPageTitle();
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.loadData();
    this.organisationList();
    this.activeUsers();
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Dashboard');
  }

  lastWeek() {
    this.myDate.setDate(this.myDate.getDate() - 7);
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.usersData = [];
    this.usersLabels = [];
    this.organisationData = [];
    this.organisationLabels = [];
    this.revenueData = [];
    this.revenueLabels = [];
    this.loadData();
  }

  nextWeek() {
    this.myDate.setDate(this.myDate.getDate() + 7);
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.usersData = [];
    this.usersLabels = [];
    this.organisationData = [];
    this.organisationLabels = [];
    this.revenueData = [];
    this.revenueLabels = [];
    this.loadData();
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    jquery('.list-group-item').addClass('remove-pointer-events');

    this.dashboardService.adminUsers(this.todayYmd)
      .pipe(

        // Get Users
        map(userData => userData.data),
        tap(userData => {
          userData.dates.forEach( value => {
            this.usersData.push(value.total);
            this.usersLabels.push(value.date);
          });
          //console.log(this.usersData);
          this.loadChart('chartUsers', 'canvas-users', 'users', this.usersLabels, this.usersData);
        }),

        // Get Organisation
        concatMap(() => this.dashboardService.adminOrganisations(this.todayYmd)),
        map(orgData => orgData.data),
        tap(orgData => {
          orgData.dates.forEach( value => {
            this.organisationData.push(value.organisations);
            this.organisationLabels.push(value.date);
          });

          this.loadChart('chartOrganisations', 'canvas-organisations', 'organisations', this.organisationLabels, this.organisationData);
        }),

        // Get Revenues
        concatMap(() => this.dashboardService.adminRevenue(this.todayYmd)),
        map(revenueData => revenueData.data),
        tap(revenueData => {
          revenueData.dates.forEach( value => {
            this.revenueData.push(value.revenue);
            this.revenueLabels.push(value.date);
          });
          //console.log(this.revenueData);
          this.loadChart('chartRevenues', 'canvas-revenue', 'revenue', this.revenueLabels, this.revenueData);
        }),

      )
      .subscribe(
        response => {
          jquery('.list-group-item').removeClass('remove-pointer-events');
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadChart(dataname = '', canvas_id = '', label = '', labels, data) {
    this[dataname] = new Chart(canvas_id, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: label,
          data: data,
          backgroundColor: ['rgba(1, 107, 132, 0.1)'],
          borderColor: ['rgba(1, 107, 132, 1)'],
          borderWidth: 2
        }]
      },
      options: {
        maintainAspectRatio: false,
        spanGaps: false,
        elements: {
          line: {
            tension: 0.000001
          }
        },
        plugins: {
          filler: {
            propagate: false
          }
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        }
      }
    });
  }

  organisationList() {
    this.organisationService.listAll()
    .subscribe(
      data => {
        let organisations = [];
        for (let key in data.data.organisation) {
          organisations.push({key: key, value: data.data.organisation[key]});
        }

        organisations.sort(this.dynamicSort("value"));

        organisations = [{key: '0', value: 'All Enterprise'}, ...organisations];

        this.organisations = organisations;

        // hide progress modal
        this.hideProgressModal();
      },
      error => {
        // hide progress modal
        this.hideProgressModal();
        this.error = true;
      }
    );
  }

  activeUsers() {
    this.showProgressModal();

    this.userService.getAllActive(this.organisationVal)
    .subscribe(
      data => {
        console.log(data.data);
        this.active_users_percentage = data.data.active_users_percentage;
        this.total_users = data.data.total_users;
        this.hideProgressModal();
      },
      error => {
        // hide progress modal
        this.hideProgressModal();
      }
    );
  }

  changeOrg() {
    this.activeUsers()
  }

  dynamicSort(property) {
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        if(sortOrder == -1){
            return b[property].localeCompare(a[property]);
        }else{
            return a[property].localeCompare(b[property]);
        }        
    }
}

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
